import { z } from 'zod';
import { UTM_TAGS as localStorageKey } from '../KEYS';

export default {
  get(): Record<string, string> | null {
    const raw = localStorage.getItem(localStorageKey);
    // Stryker disable next-line ConditionalExpression: equivalent — a null row would go through JSON.parse as "null" and be rejected by the record schema into the same null; this line is the fast path and the TS narrowing.
    if (raw === null) return null;
    try {
      const parsed = z
        .record(z.string(), z.string())
        .safeParse(JSON.parse(raw));
      return parsed.success ? parsed.data : null;
    } catch {
      return null;
    }
  },

  set(value: Record<string, string>) {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  },
};
